import React from "react";

function ProductCarouselSchema({ productData }) {

  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  const itemList = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Product Carousel",
    "itemListElement": productData.map((product, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "item": {
        "@type": "Product",
        "name": product.product_name,
        "image": product.product_image,
        "description": product.product_description,
        "sku": product.product_sku,

        "brand": {
          "@type": "Brand",
          "name": "Ashna Vaswani"
        },

        "offers": {
          "@type": "Offer",
          "url": "https://ashnavaswani.com/product/" + product.product_slug,
          "priceCurrency": "INR",
          "price": product.product_selling_price,
          "itemCondition": "https://schema.org/NewCondition",
          "availability": "https://schema.org/InStock"
        },

        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.5",
          "reviewCount": randomNumberInRange(50, 60)
        }
      }
    }))
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(itemList)}
    </script>
  );
}

export default ProductCarouselSchema;
